module.exports = __webpack_public_path__ + "static/img/banner4_mb.73882547.png";